import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { brand } from '../../shared-theme/brand';

const stats = [
  { value: '18,000+', label: 'calls answered for law firms each month' },
  { value: '<10s', label: 'speed to lead on web inquiries' },
  { value: '24/7', label: 'answering, including nights, weekends, and holidays' },
];

const channels = [
  'Phone',
  'SMS',
  'Email',
  'Web chat',
  'WhatsApp',
  'Messenger',
  'Instagram',
];

// Full-bleed operational-proof band: the numbers that say this platform is
// running in production, not a pitch deck.
export default function ProofSlab() {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: brand.brown,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            color: brand.ivory,
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            fontWeight: 500,
            letterSpacing: '-0.025em',
            maxWidth: 640,
            mb: { xs: 5, md: 6 },
            textAlign: { xs: 'center', md: 'left' },
            mx: { xs: 'auto', md: 0 },
          }}
        >
          Already picking up the phone for firms like yours
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: { xs: 4, md: 6 },
            borderTop: '1px solid rgba(253, 252, 249, 0.18)',
            pt: { xs: 4, md: 5 },
          }}
        >
          {stats.map((stat) => (
            <Box key={stat.label} sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography
                sx={{
                  color: brand.ivory,
                  fontSize: { xs: '2.75rem', md: '3.5rem' },
                  fontWeight: 500,
                  letterSpacing: '-0.04em',
                  lineHeight: 1.1,
                  mb: 1,
                }}
              >
                {stat.value}
              </Typography>
              <Typography
                sx={{
                  color: 'rgba(253, 252, 249, 0.75)',
                  fontSize: '0.95rem',
                  lineHeight: 1.5,
                  maxWidth: 280,
                  mx: { xs: 'auto', sm: 0 },
                }}
              >
                {stat.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Channel strip: every door a lead can walk through */}
        <Box
          sx={{
            mt: { xs: 5, md: 6 },
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-start' },
            columnGap: 2.5,
            rowGap: 1.5,
          }}
        >
          <Typography
            sx={{
              color: 'rgba(253, 252, 249, 0.6)',
              fontSize: '0.9rem',
              mr: 0.5,
            }}
          >
            Works across
          </Typography>
          {channels.map((channel) => (
            <Typography
              key={channel}
              sx={{
                color: 'rgba(253, 252, 249, 0.85)',
                fontSize: '0.875rem',
                fontWeight: 500,
                px: 1.5,
                py: 0.5,
                borderRadius: '50px',
                border: '1px solid rgba(253, 252, 249, 0.22)',
              }}
            >
              {channel}
            </Typography>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
